import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import {
  motion, useAnimation, useMotionValueEvent, useScroll,
} from 'framer-motion';
import Link from 'next/link';

// Utils
import { cn } from 'utils';
// Styles
import styles from './ResidenceMenuNavigation.module.css';
// Components
import Button from '../../atoms/Button/Button';
import { Picto } from '../../atoms/Picto/Picto';
// Constants
import { CONTACT_SLUG } from '../../../src/constants';

function ResidenceMenuNavigation({
  name, bookingUrl, displayContact, displayBooking, logo, phone, pmsId,
}) {
  const {
    // query, push, asPath,
    push,
  } = useRouter();
  const { t } = useTranslation();
  const contactLink = `/${CONTACT_SLUG}#residence=${pmsId}&phone=call&number=${phone.replace(/ /g, '')}`;

  const controls = useAnimation();
  const { scrollY } = useScroll();
  useMotionValueEvent(scrollY, 'change', (latest) => {
    controls.start({
      opacity: latest >= 80 ? 1 : 0,
      width: latest >= 80 ? 40 : 0,
      marginRight: latest >= 80 ? 16 : 0,
      transition: { opacity: { duration: 0.2 }, width: { duration: 0.1 } },
    });
  });

  // const activeMenu = useMemo(() => {
  //   const active = menu?.find(({ data: { url } }) => (asPath.indexOf(url) >= 0 ? url : null));
  //   return active?.data;
  // }, [query]);

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <div className={styles.nameContainer}>
            {logo?.url ? (
              <motion.div
                className={styles.logoContainer}
                initial={{ opacity: 0 }}
                animate={controls}
                transition={{ duration: 0.3 }}
              >
                <Image
                  fill
                  src={logo?.url}
                  alt={logo?.description}
                  className={styles.logo}
                  sizes="256px"
                />
              </motion.div>
            ) : null}
            <div className={styles.name}>{name}</div>
          </div>
          <div className={styles.mobileActions}>
            {displayContact ? (
              <a href={contactLink} className={cn([styles.phoneMobile, styles.mobile])} aria-label="phone">
                <Picto icon="call" className={styles.mobileActionsPicto} />
                <span>{t('residence.contactPictoLabel')}</span>
              </a>
            ) : null}
          </div>
        </div>

        <div className={styles.right}>
          <div className={styles.contactButtons}>
            {phone ? (
              <a href={`tel:${phone}`} className={styles.phone} aria-label={phone}>
                <Picto icon="call" className="margin-right-8" />
                {phone}
              </a>
            ) : null}
            {displayContact ? (
              <Link href={contactLink}>
                <Button
                  CTAType="primary"
                  usageContext="neutral"
                  className={styles.link}
                >
                  {t('residence.contact')}
                </Button>
              </Link>
            ) : null}
          </div>
          {bookingUrl && displayBooking ? (
            <Button onClick={() => push(bookingUrl)}>
              {t('residence.booking')}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

ResidenceMenuNavigation.propTypes = {
  name: PropTypes.string,
  bookingUrl: PropTypes.string,
  displayContact: PropTypes.bool,
  displayBooking: PropTypes.bool,
  logo: PropTypes.shape({
    url: PropTypes.string,
    description: PropTypes.string,
  }),
  phone: PropTypes.string,
  pmsId: PropTypes.string,
};

ResidenceMenuNavigation.defaultProps = {
  name: '',
  bookingUrl: '',
  displayContact: false,
  displayBooking: false,
  logo: {},
  phone: '',
  pmsId: '',
};

export default ResidenceMenuNavigation;
